/**
 * The journal kind's guard — `EntrySlice.guard`, once the registry (#312) binds it.
 *
 * It had no call site in `storage/schema/entries.ts`, which is the shape #359 measured across all
 * eight guards: exactly one, `isTaskEntry`, was called anywhere. A guard with no caller is what an
 * interface with no seam over it looks like; the registry is the seam that gives this one a job.
 */

import type { Entry } from '@/document'
import type { JournalEntry } from './meta'

export function isJournalEntry(entry: Entry): entry is JournalEntry {
  return entry.type === 'journal'
}
